import { Badge } from "reactstrap";

export const convertRPInputToIntValue = (value) => {
  if (!value) {
    return 0;
  }
  let numericValue = value
    .replace(/,/g, "")
    .replace(/ /g, "")
    .replace(".00", "");

  if (isNaN(numericValue) || numericValue < 0 || numericValue === "") {
    numericValue = 0;
  }

  if (numericValue.length > 1 && numericValue[0] === "0") {
    numericValue = numericValue.substring(1, numericValue.length);
  }

  return numericValue;
};

export const getStatusBadge = (statusData) => {
  return statusData !== null ? (
    <Badge color={statusData.color} pill>
      {statusData.nama_status}
    </Badge>
  ) : (
    <Badge color={"dark"} pill>
      Kosong
    </Badge>
  );
};

// leave the space so that it won't make the class not work when combined with other class
export const getDarkTableRow = (themeContext) => {
  return themeContext === "dark" ? " bg-transparent " : " ";
};

export const getDarkDropdown = (themeContext) => {
  return themeContext === "dark" ? " text-white " : " ";
};

export const getDarkInput = (themeContext) => {
  return themeContext === "dark" ? " bg-transparent text-white " : " ";
};
